import { shopCLient } from '@/services/axiosConfig'
import { CartRes, MergeCartReq } from './types'

export type MergeCartResp = CartRes

type MergeCart = (isdn: string, req: MergeCartReq) => Promise<MergeCartResp>

export const mergeCart: MergeCart = async (isdn, req) => {
  try {
    const res = await shopCLient.post(`/service/merge-cart?isdn=${isdn}`, req)
    return res.data.response
  } catch (e) {
    console.error(e)
  }
}
